import React from 'react';
import { motion } from 'framer-motion';
import { CalendarDays, Sun, Moon } from 'lucide-react';

const RamadanCalendar = () => {
  const currentDay = 15; // Mock current day

  const ramadanDays = Array.from({ length: 30 }, (_, i) => ({
    day: i + 1,
    date: `${i + 1} Mars 2026`,
    imsaku: `0${4 + Math.floor(i / 10)}:${20 + (i % 6) * 5}`,
    iftari: `1${7 + Math.floor(i / 15)}:${30 + (i % 6) * 4}`,
  }));

  return (
    <section id="ramazani" className="py-16 md:py-24 bg-background" data-testid="ramadan-section">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-4">Kalendari i Ramazanit</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Orari i plotë i Imsakët dhe Iftarit për muajin e begatshëm të Ramazanit
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="bg-card rounded-2xl shadow-lg overflow-hidden"
        >
          {/* Header */}
          <div className="bg-gradient-to-r from-primary to-primary-700 p-6">
            <div className="grid grid-cols-4 gap-4 text-white font-semibold">
              <div className="flex items-center gap-2">
                <CalendarDays className="w-5 h-5" />
                <span>Dita</span>
              </div>
              <div>Data</div>
              <div className="flex items-center gap-2">
                <Moon className="w-5 h-5" />
                <span>Imsaku</span>
              </div>
              <div className="flex items-center gap-2">
                <Sun className="w-5 h-5" />
                <span>Iftari</span>
              </div>
            </div>
          </div>

          {/* Calendar Grid */}
          <div className="max-h-[600px] overflow-y-auto">
            {ramadanDays.map((day) => (
              <div
                key={day.day}
                className={`grid grid-cols-4 gap-4 p-4 border-b border-gray-100 transition-colors ${
                  day.day === currentDay
                    ? 'bg-accent/10 border-l-4 border-l-accent font-semibold'
                    : 'hover:bg-muted'
                }`}
                data-testid={`ramadan-day-${day.day}`}
              >
                <div className="flex items-center">
                  <span className={`w-10 h-10 rounded-full flex items-center justify-center ${
                    day.day === currentDay ? 'bg-accent text-white' : 'bg-muted text-foreground'
                  }`}>
                    {day.day}
                  </span>
                </div>
                <div className="flex items-center text-muted-foreground">{day.date}</div>
                <div className="flex items-center font-semibold text-primary">{day.imsaku}</div>
                <div className="flex items-center font-semibold text-accent">{day.iftari}</div>
              </div>
            ))}
          </div>

          {/* Footer Info */}
          <div className="bg-muted p-6 text-center">
            <p className="text-sm text-muted-foreground">
              <span className="font-semibold text-accent">Shënim:</span> Kohët janë të llogaritura sipas kalendarit islamik për Tiranën, Shqipëri
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default RamadanCalendar;